import { fleet } from "@/mocks/homeData";
import { WHATSAPP_LINK } from "@/pages/home/constants";

const FLEET_IMAGE_ALT: Record<string, string> = {
  "lake-hunter": "Lancha Lake Hunter para 14 passageiros em Capitólio no Lago de Furnas",
  val: "Lancha Vall para 15 passageiros em Capitólio no Lago de Furnas",
  luna: "Lancha Luna para 12 passageiros em Capitólio no Lago de Furnas",
  "dream-sea": "Lancha Dream Sea para 19 passageiros com banheiro em Capitólio",
};

const FLEET_ANCHOR: Record<string, string> = {
  "lake-hunter": "lancha-lake-hunter",
  val: "lancha-vall",
  luna: "lancha-luna",
  "dream-sea": "lancha-dream-sea",
};

export default function Fleet() {
  return (
    <section id="nossas-lanchas" className="relative py-7 md:py-10 bg-background-50 scroll-mt-16">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-4 md:mb-7 reveal">
            <span className="inline-block text-[11px] md:text-xs font-semibold uppercase tracking-[0.2em] text-accent-700 mb-3">
              Nossas embarcações
            </span>
            <h2 className="text-xl md:text-3xl font-heading font-bold text-primary-900 mb-3">
              Nossas Lanchas — a Frota Eco Tour Turismo
            </h2>
            <p className="text-xs md:text-sm text-foreground-600 max-w-xl mx-auto">
              Lanchas modernas, revisadas e equipadas para segurança e conforto. Nossa frota atende locação e
              aluguel de lancha em Capitólio para famílias, casais e grupos de até 19 passageiros.
            </p>
          </div>

          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-6">
            {fleet.map((boat, index) => (
              <article
                key={boat.id}
                id={FLEET_ANCHOR[boat.id]}
                className={`reveal reveal-delay-${(index % 4) + 1} group flex flex-col bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-500/60 transition-all duration-300 scroll-mt-16`}
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={boat.image}
                    alt={FLEET_IMAGE_ALT[boat.id] ?? `Lancha ${boat.name}`}
                    title={`${FLEET_IMAGE_ALT[boat.id] ?? `Lancha ${boat.name}`} | Eco Tour Turismo`}
                    className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-full bg-primary-950/80 px-2 py-0.5 text-[9px] md:text-[11px] font-bold text-white whitespace-nowrap">
                    <i className="ri-user-3-line text-accent-400 text-[10px]" />
                    {boat.capacity}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-3 md:p-4">
                  <h3 className="text-xs md:text-base font-heading font-bold text-primary-900 mb-1">
                    {boat.name}
                  </h3>
                  <p className="text-[10px] md:text-sm text-foreground-600 leading-relaxed flex-1 mb-3">
                    {boat.description}
                  </p>
                  <div className="flex flex-wrap gap-1 md:gap-1.5 mb-3">
                    {boat.features.map((feature) => {
                      const isGrill = feature.label === "Churrasqueira";
                      return (
                        <span
                          key={feature.label}
                          className={`inline-flex items-center gap-1 rounded-full border px-1.5 md:px-2 py-0.5 text-[9px] md:text-[11px] font-semibold whitespace-nowrap ${
                            isGrill
                              ? "border-accent-300 bg-accent-100 text-accent-900"
                              : "border-background-300/60 bg-background-100 text-foreground-600"
                          }`}
                        >
                          <i
                            className={`${feature.icon} text-[10px] md:text-xs ${
                              isGrill ? "text-accent-700" : "text-primary-500"
                            }`}
                          />
                          {feature.label}
                        </span>
                      );
                    })}
                  </div>
                  <a
                    href={WHATSAPP_LINK}
                    data-whatsapp-cta
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-1 text-[11px] md:text-xs font-bold text-primary-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Consulte disponibilidade
                    <i className="ri-arrow-right-line text-sm" />
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}